// extracted by mini-css-extract-plugin
module.exports = {"footerFlex":"Footer_footerFlex__2ebvp","innerFlex":"Footer_innerFlex__3ngp2","footerList":"Footer_footerList__3ZsxU"};